import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ScreenMode, ScreenModeService } from 'ib/internetbank-core/ib-services/screen-mode.service';

import { environment } from '../environments/environment';

import { NspkPageComponent } from './pages-shared/nspk-page/nspk-page.component';


const appRoutes: Routes = [
	{
		path: `${NspkPageComponent.path}/:payType/:qrId`,
		loadComponent: () => import('./pages-shared/nspk-page/nspk-page.component')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((p) => p.NspkPageComponent),
	},
	{
		path: 'new',
		loadChildren: () => import('./pages-desktop/pages-desktop.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.PagesDesktopModule),
	},
	{
		path: 'login',
		loadChildren: () => import('./authorization/login/login.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.LoginModule),
	},
	{
		path: 'digital-code-authn',
		loadChildren: () => import('./authorization/pin-code-authn/pin-code-authn.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.PinCodeAuthnModule),
	},
	{
		path: 'mobile/digital-code-authn',
		loadChildren: () => import('./authorization/pin-code-authn/pin-code-authn.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.PinCodeAuthnModule),
	},
	{
		path: 'web-authn',
		loadChildren: () => import('./authorization/web-authn/web-authn.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.WebAuthnModule),
	},
	{
		path: 'mobile/web-authn',
		loadChildren: () => import('./authorization/web-authn/web-authn.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.WebAuthnModule),
	},
	{
		path: 'mobile',
		loadChildren: () => import('./pages/pages.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.PagesModule),
	},
	{
		path: 'waiting',
		loadChildren: () => import('./pages-shared/waiting-page/waiting-page.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.WaitingPageModule),
	},
	{
		path: 'mobile/waiting',
		loadChildren: () => import('./pages-shared/waiting-page/waiting-page.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.WaitingPageModule),
	},
	{
		path: '',
		loadChildren: () => import('./sections/sections.module')
			// eslint-disable-next-line @typescript-eslint/typedef
			.then((m) => m.SectionsModule),
	},
	{
		path: '**',
		redirectTo: new ScreenModeService().screenMode === ScreenMode.MOBILE
			? 'mobile'
			: '',
	},
];

if (!environment.production) {
	appRoutes.push(
		{
			path: 'playground',
			loadChildren: () => import('./playground/playground.module')
				// eslint-disable-next-line @typescript-eslint/typedef
				.then((m) => m.PlaygroundModule),
		},
	)
}

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			{
				onSameUrlNavigation: 'reload',
				anchorScrolling: 'enabled',
			},
		),
	],
	exports: [RouterModule],
	providers: [
		// { provide: APP_BASE_HREF, useValue: '#' },
		// { provide: LocationStrategy, useClass: HashLocationStrategy },
	],
})
export class AppRoutingModule { }
